import { render, staticRenderFns } from "./ExamHistory.vue?vue&type=template&id=3bc6deab&scoped=true"
import script from "./ExamHistory.vue?vue&type=script&lang=js"
export * from "./ExamHistory.vue?vue&type=script&lang=js"
import style0 from "./ExamHistory.vue?vue&type=style&index=0&id=3bc6deab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6deab",
  null
  
)

export default component.exports